import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import { initGoogleAnalytics } from './ganalytics'
import { initSentry } from './plugins/sentry';

import store from './store'

Vue.config.productionTip = false

initSentry(Vue, router);
initGoogleAnalytics(Vue, router);

new Vue({
  vuetify,
  router,
  render: h => h(App),
  data: {
    sharedState: store.state
  }
}).$mount('#app')
